module.exports = __webpack_public_path__ + "static/media/i8-logo_backup.1e0561cf.png";